// extracted by mini-css-extract-plugin
export var creditCardImg = "comparisonTable-module--creditCardImg--2DY+m";
export var halvaImg = "comparisonTable-module--halvaImg--DeV5e";
export var img = "comparisonTable-module--img--WDFnc";
export var secondContainer = "comparisonTable-module--secondContainer--ZL0Ek";
export var section = "comparisonTable-module--section--+5rQX";
export var table = "comparisonTable-module--table--2c4q0";
export var tableRow = "comparisonTable-module--tableRow--atd89";
export var tableRow1 = "comparisonTable-module--tableRow1--JdP5D";
export var tableRow2 = "comparisonTable-module--tableRow2--UJ-B0";
export var tableRow3 = "comparisonTable-module--tableRow3--M9eVs";
export var tableSubtitle = "comparisonTable-module--tableSubtitle--YP8a1";
export var tableText = "comparisonTable-module--tableText--soB4M";
export var tableTitle = "comparisonTable-module--tableTitle--c2wXM";